<template>
  <div id="app">
    <transition name="fade">
      <div id="root" :class="$route.name.toLowerCase()">
        <router-view/>
      </div>
    </transition>

    <!-- TODO: @danealton вынести алерты в модуль и вызывать через vue-embedded-container-listener -->
    <capustaAlert/>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';

import { EVENT_BUS } from '@/eventBus';

export default {
  name: 'PaymentApplication',
  head: {
    script: [
      {
        inner: '(function(m,e,t,r,i,k,a){m[i]=m[i]||function(){(m[i].a=m[i].a||[]).push(arguments)}; m[i].l=1*new Date();k=e.createElement(t),a=e.getElementsByTagName(t)[0],k.async=1,k.src=r,a.parentNode.insertBefore(k,a)}) (window, document, "script", "https://mc.yandex.ru/metrika/tag.js", "ym"); ym(60933172, "init", { clickmap:true, trackLinks:true, accurateTrackBounce:true, webvisor:true });',
      },
    ],
    noscript: [
      {
        inner: '<div><img src="https://mc.yandex.ru/watch/60933172" style="position:absolute; left:-9999px;" alt="" /></div>',
      },
    ],
  },
  created() {
    EVENT_BUS.$on('change.locale', language => {
      this.$i18n.locale = language.code.toLowerCase();
      this.$store.commit('SET_LANGUAGE', language);
    });
  },
  mounted() {
    window.addEventListener('message', this.receive3dsMessage);
  },
  beforeDestroy() {
    window.removeEventListener('message', this.receive3dsMessage);
  },
  computed: {
    ...mapState([
      'PROJECT',
      'PROJECT_LOCALE',
      'TRANSACTION_KEY',
    ]),
  },
  methods: {
    // TODO: @danealton разобраться зачем это надо
    receive3dsMessage(message) {
      if (message.data.result === 'wait') {
        this.$router.push({ name: 'payment.origin' });
      } else if (message.data.result === 'fail') {
        this.$router.push({ name: 'failed.payment' });
      }
    },
    ...mapMutations(['SET_LANGUAGE']),
  },
};
</script>

<style lang="sass">
  .fade-enter-active, .fade-leave-active
    transition: opacity .24 ease-in

  .fade-enter, .fade-leave-to /* .fade-leave-active до версии 2.1.8 */
    opacity: 0
</style>
